/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 04.12.12, 10:07
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { FontConfigVO } from "../FontConfigVO";
import { RuntimeLoadedFontConfigVO } from "../RuntimeLoadedFontConfigVO";

export class FontConfigUtil {
    public static getDeepCopy(inputFontConfigVO: FontConfigVO): FontConfigVO {
        let outputFontConfigVO: FontConfigVO = FontConfigUtil.createFontConfigVO(inputFontConfigVO);
        outputFontConfigVO.fontName = inputFontConfigVO.fontName;
        outputFontConfigVO.yOffset = inputFontConfigVO.yOffset;
        outputFontConfigVO.fontStyle = inputFontConfigVO.fontStyle;
        outputFontConfigVO.fontScale = inputFontConfigVO.fontScale;
        outputFontConfigVO.fontSizeMinimum = inputFontConfigVO.fontSizeMinimum;

        return outputFontConfigVO;
    }

    private static createFontConfigVO(inputFontConfigVO: FontConfigVO): FontConfigVO {
        if (inputFontConfigVO instanceof RuntimeLoadedFontConfigVO) {
            return new RuntimeLoadedFontConfigVO(((<RuntimeLoadedFontConfigVO>inputFontConfigVO)).ggsLanguageCode);
        }

        return new FontConfigVO();
    }
}
